import React from 'react';
const INK = '#01332b';
const SHELL = '#FFFFFF';
const SHADE = '#EDEFEC';
const WARM = '#E2703A';
const BARREL = '#2F7DD1';
const BLACK = '#151515';
interface WarmerVisualProps {
  className?: string;
}

/**
 * Credible rendering of the Solventum Filtek Composite Warmer:
 * a conical warming body on a rounded base, loaded with capsules and a syringe.
 */
export function WarmerVisual({
  className = ''
}: WarmerVisualProps) {
  return <svg viewBox="0 0 170 268" className={className} role="img" aria-label="Filtek composite warmer device with a syringe warming in the holder" data-id="element-258" data-mp="2ufl4na97qqua">
      <ellipse cx="85" cy="256" rx="48" ry="6" fill={INK} opacity="0.14" data-id="element-259" data-mp="2lf6jcaw91bqs" />

      {/* warmth cues */}
      <g fill="none" stroke={WARM} strokeWidth="2.4" strokeLinecap="round" opacity="0.75" data-id="element-260" data-mp="2qcf1ibhedfs1">
        <path d="M52 96 c7 -8 -7 -15 0 -23" data-id="element-261" data-mp="19yykokjxukke" />
        <path d="M85 84 c7 -8 -7 -15 0 -23" data-id="element-262" data-mp="1a1b12ta1smvc" />
        <path d="M118 96 c7 -8 -7 -15 0 -23" data-id="element-263" data-mp="1eyuhnzu7xbqg" />
      </g>

      {/* base */}
      <path d="M85 198 c30 0 55 8 55 20 v4 c0 13 -25 22 -55 22 s-55 -9 -55 -22 v-4 c0 -12 25 -20 55 -20 z" fill={SHELL} stroke={INK} strokeWidth="2.2" data-id="element-264" data-mp="h9vvemb6k5zh" />
      <circle cx="85" cy="216" r="8" fill="none" stroke={INK} strokeWidth="1.6" opacity="0.28" data-id="element-265" data-mp="cd5b1msceo89" />
      <circle cx="63" cy="218" r="3.4" fill="none" stroke={INK} strokeWidth="1.5" opacity="0.28" data-id="element-266" data-mp="r5p4fvpoxhci" />
      <path d="M63 214.6 v2" stroke={INK} strokeWidth="1.5" opacity="0.28" strokeLinecap="round" data-id="element-267" data-mp="mbbe47pvy0ep" />
      <circle cx="107" cy="218" r="3.4" fill="none" stroke={INK} strokeWidth="1.5" opacity="0.28" data-id="element-268" data-mp="106dhoo79fdoc" />
      <path d="M107 214.6 v2" stroke={INK} strokeWidth="1.5" opacity="0.28" strokeLinecap="round" data-id="element-269" data-mp="v7sp9ay91yag" />
      <text x="85" y="238" textAnchor="middle" fill={INK} opacity="0.38" fontFamily="Inter, sans-serif" fontSize="7.5" fontWeight="600" letterSpacing="1.4" data-id="element-270" data-mp="1a0dwxiw99zas">
        FILTEK
      </text>

      {/* cord */}
      <path d="M139 220 q16 3 20 16" fill="none" stroke={INK} strokeWidth="2.6" strokeLinecap="round" opacity="0.8" data-id="element-271" data-mp="1evjey6mjettl" />

      {/* cone body */}
      <path d="M57 122 c0 -6 6 -10 28 -10 s28 4 28 10 l10 74 c0 8 -17 12 -38 12 s-38 -4 -38 -12 z" fill={SHELL} stroke={INK} strokeWidth="2.2" data-id="element-272" data-mp="1qxt2sgxl9iag" />
      <path d="M113 122 l10 74 c0 8 -17 12 -38 12 v-96 c22 0 28 4 28 10 z" fill={SHADE} opacity="0.7" data-id="element-273" data-mp="20r9v1gi2upc0" />
      <ellipse cx="85" cy="122" rx="28" ry="9.5" fill={SHADE} stroke={INK} strokeWidth="2" data-id="element-274" data-mp="29qeuqq5dkopr" />

      {/* capsule holders */}
      {[{
      x: 68,
      r: -7
    }, {
      x: 79,
      r: -2.5
    }, {
      x: 91,
      r: 2.5
    }, {
      x: 102,
      r: 7
    }].map(c => <g key={c.x} transform={`rotate(${c.r} ${c.x} 122)`} data-id="element-275" data-mp="2jo2rtmqge8b3">
          <rect x={c.x - 4} y="96" width="8" height="28" rx="3" fill={BLACK} data-id="element-276" data-mp="kc0deqwos44a" />
          <rect x={c.x - 4} y="96" width="3" height="28" fill="#2E2E2E" data-id="element-277" data-mp="pajuoe0c4rqb" />
          <path d={`M${c.x + 4} 112 l7 3 -7 3 z`} fill={BARREL} data-id="element-278" data-mp="pcnzqz9yzws6" />
        </g>)}

      {/* syringe warming in the holder */}
      <g transform="rotate(-42 85 116)" data-id="element-279" data-mp="2xt1ws2efyhde">
        <rect x="60" y="112" width="27" height="8" rx="4" fill={SHELL} stroke={INK} strokeWidth="1.6" data-id="element-280" data-mp="2xsa2qw0hsrp8" />
        <rect x="18" y="108" width="44" height="16" rx="7" fill={BARREL} stroke={INK} strokeWidth="1.8" data-id="element-281" data-mp="2orbyccm56i64" />
        <ellipse cx="20" cy="116" rx="4" ry="11" fill={BLACK} data-id="element-282" data-mp="3hivokgh5owhm" />
        <rect x="3" y="113.5" width="17" height="5" rx="2.5" fill={SHELL} stroke={INK} strokeWidth="1.4" data-id="element-283" data-mp="3chy6s50264gn" />
        <ellipse cx="4" cy="116" rx="4" ry="8" fill={SHELL} stroke={INK} strokeWidth="1.6" data-id="element-284" data-mp="37j4pe1hnhtb7" />
      </g>
    </svg>;
}